<div
  #container
  class="debug-split-container"
  [class.is-dragging]="isDragging"
  >

  <!-- Left: Bot Preview Iframe -->
  <div
    class="debug-split-left"
    [style.width.%]="leftWidthPercent"
    >
    @if (sanitizedPreviewUrl) {
      <iframe
        [src]="sanitizedPreviewUrl"
      ></iframe>
    }
  </div>

  <!-- Draggable Divider -->
  <div
    class="debug-split-divider"
    (mousedown)="startDrag($event, container)"
    >
    <div class="debug-split-handle"></div>
  </div>

  <!-- Right: Debug Log -->
  <div class="debug-split-right">
    <app-debug-view [botId]="botId" />
  </div>

</div>
